// extracted by mini-css-extract-plugin
export default {"formItem":"NumberField_formItem__6IgEY","form":"NumberField_form__N01Xm","form__error":"NumberField_form__error__vOsyH"};